import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiservicesService } from './apiservices.service';

export type FollowupListType = 'lead' | 'rep';

export interface FollowupListPayload {
  condition: { limit: number; skip: number };
  sort: { field: string; type: 'asc' | 'desc' };
  searchcondition: Record<string, any>;
  project?: Record<string, any>;
  token?: string;
}

@Injectable({
  providedIn: 'root',
})
export class FollowupApiService {
  constructor(private api: ApiservicesService) { }

  buildListPayload(params: {
    limit: number;
    skip: number;
    sortField: string;
    sortType: 'asc' | 'desc';
    searchcondition?: Record<string, any>;
  }): FollowupListPayload {
    return {
      condition: { limit: params.limit, skip: params.skip },
      searchcondition: params.searchcondition ?? {},
      sort: { field: params.sortField, type: params.sortType },
      project: {},
      token: '',
    };
  }

  list(type: FollowupListType, payload: FollowupListPayload): Observable<any> {
    return this.api.getHttpDataPost(this.endpoint(type), payload);
  }

  count(type: FollowupListType, payload: FollowupListPayload): Observable<any> {
    return this.api.getHttpDataPost(this.countEndpoint(type), payload);
  }

  add(payload: any): Observable<any> {
    return this.api.getHttpDataPost('followup/followup-add', payload);
  }

  private endpoint(type: FollowupListType): string {
    return type === 'rep' ? 'followup/rep-followup-list' : 'followup/follow-list';
  }

  private countEndpoint(type: FollowupListType): string {
    return type === 'rep'
      ? 'followup/rep-followup-list-count'
      : 'followup/follow-list-count';
  }
}
